/**
 * Item types supported by VRL
 * @type {Object}
 */
export const itemTypes = {
  image: ['JPG', 'JPEG', 'PNG', 'PSD', 'TIF', 'TIFF'],
  audio: ['MP3'],
};

export const itemHeight = {
  image(nodeDimensions, { height = 400, width = 400 } = {}) {
    if (!nodeDimensions) {
      return 0;
    }

    const ratio = height / width;

    return Math.round(nodeDimensions.width * ratio);
  },
  audio() {
    return 100;
  },
};

/**
 * Guess the item type (image, audio, ...) based on type provided by backend
 * @param  {Object} item Item description provided by backend
 * @return {String}      Item type
 */
export const getItemType = (item) => {
  let itemType = '';

  Object.keys(itemTypes).some((type) => {
    if (itemTypes[type].includes(item.type.toUpperCase())) {
      itemType = type;
      return true;
    }
    return false;
  });

  return itemType;
};

// Grid is displayed when transfer consists of at least 2 items
// One of those items must be previewable
export const canBeShownAsGrid = (items = []) =>
  items.length > 1 && items.some(({ previewable }) => previewable);

export const isPreviewable = ({ items, password_protected }) => {
  if (password_protected) return false;

  return items.some(({ file: { type } }) => {
    return itemTypes.image.includes(type) || itemTypes.audio.includes(type);
  });
};

// We currently do not support MP3 previews in Projects
export const containsMP3FilesOnly = ({ items }) => {
  return items.every((item) => item.file.type === 'MP3');
};
